import { useMutation, useQueryClient } from "@tanstack/react-query";
import { projectDetailsApi } from "..";

export const usePhase = () => {

    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (projectId: string | number | undefined) => {
            return await projectDetailsApi.fetchProjectPhases(String(projectId));
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });

};